import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, SunriseIcon, CompassIcon } from 'lucide-react';
const stages = [{
  icon: BookOpenIcon,
  label: 'While Reading',
  points: ['The illusion starts breaking', 'Shame begins disappearing', 'Urges start losing emotional power']
}, {
  icon: SunriseIcon,
  label: 'First Week',
  points: ['Brain fog starts lifting', 'Mental clarity improves', 'Sleep and energy stabilize']
}, {
  icon: CompassIcon,
  label: 'First Month',
  points: ['Confidence returns', 'Emotional presence improves', 'You stop feeling controlled']
}];
export function Timeline() {
  return <section className="py-14 sm:py-16 bg-charcoal-light relative border-y border-gold/5" data-id="element-139">
      <div className="max-w-5xl mx-auto px-6" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="text-gold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-142">
            The Journey
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="font-serif text-4xl sm:text-5xl text-ivory" data-id="element-143">
            What Finally Changes After Reading UNHOOKED
          </motion.h2>
        </div>

        <div className="relative" data-id="element-144">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-8 left-0 w-full h-px bg-gold/20" data-id="element-145" />

          {/* Mobile connecting line */}
          <div className="md:hidden absolute top-0 left-8 bottom-0 w-px bg-gold/20" data-id="element-146" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-147">
            {stages.map((stage, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: index * 0.2,
            duration: 0.8
          }} className="relative flex md:flex-col items-start md:items-center gap-6 md:gap-8" data-id="element-148">
                <div className="relative z-10 flex-shrink-0 w-16 h-16 rounded-full border border-gold/40 bg-charcoal flex items-center justify-center text-gold shadow-glow-gold" data-id="element-149">
                  <stage.icon className="w-6 h-6" data-id="element-150" />
                </div>

                <div className="md:text-center pt-2 md:pt-0" data-id="element-151">
                  <h3 className="text-gold tracking-widest uppercase text-sm mb-6 font-medium" data-id="element-152">
                    {stage.label}
                  </h3>
                  <ul className="space-y-4" data-id="element-153">
                    {stage.points.map((point, i) => <li key={i} className="text-ivory/80 text-base sm:text-lg font-light leading-relaxed" data-id="element-154">
                        {point}
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}